// Design tokens v1 — extracted from Pencil iteration 2 (Commitment Tracker + hover state).
// To be refined as Pencil delivers Account detail, AI Thread, Settings, Login screens.
// Last updated: 2026-05-03

export const colors = {
  // Surfaces — three-tier hierarchy: canvas (page bg) → raised (cards) → recessed (empty states)
  canvas: '#F5F1E8',              // Parchment
  raised: '#FAFAF7',              // paper-white (cards float above canvas)
  recessed: '#EFEBE0',            // empty-state inset

  // Text
  textPrimary: '#0B0B0F',         // Ink — body, headings
  textSecondary: '#5F5C52',       // Stone-deep — labels, metadata
  textTertiary: '#8A8880',        // Stone — placeholders, captions
  textInverse: '#FAFAF7',         // for use on Teal/Ember solid backgrounds

  // Borders
  borderSubtle: '#E5E0D2',        // 1px default on cards, dividers
  borderDefault: '#D4CEBC',       // input borders at rest
  borderHover: '#1F4E4A',         // Teal — confirmed by hover state image

  // Brand & accent palette (use sparingly)
  teal: '#1F4E4A',                // primary brand, single primary action per screen
  ember: '#C76B3A',               // urgency, overdue, danger
  gold: '#D9A91E',                // completion, achievement, recently-done
  sage: '#6B8E7F',                // in-progress, on-track, success

  // Pale tint variants (for tag backgrounds, filter pills, avatar circles)
  tealTint: '#D5E0DD',
  emberTint: '#F5DCC8',
  goldTint: '#F5E8C2',
  sageTint: '#E0E8E2',

  // Tag pills (confirmed by Pencil's Compliance/ACA pills)
  tagCategoryBg: '#E0E8E2',       // pale Sage — for Compliance, Onboarding, Renewal, etc.
  tagCategoryText: '#1F4E4A',     // Teal text on pale Sage bg
  tagRegulatoryBg: '#F5DCC8',     // pale Ember — for ACA, ERISA, COBRA, HIPAA
  tagRegulatoryText: '#C76B3A',   // Ember text on pale Ember bg

  // Avatar
  avatarBg: '#E0E8E2',            // pale Sage circle (confirmed by LH, AE, SM, etc.)
  avatarText: '#5F5C52',          // Stone-deep initials

  // Date colorization
  dateOverdue: '#C76B3A',         // Ember text for past-due
  dateFuture: '#5F5C52',          // Stone-deep for future

  // Active filter pill
  filterPillBg: '#E0E8E2',        // pale Sage
  filterPillText: '#1F4E4A',      // Teal
  filterPillBorder: 'transparent',

  // Status — kanban left-edge stripes + CFD chart bands
  status: {
    backlog: 'transparent',       // no stripe (default state)
    ready_for_work: '#8A8880',    // Stone (workflow-ready, not yet started)
    in_progress: '#6B8E7F',       // Sage
    in_review: '#D9A91E',         // Gold
    done: '#D9A91E',              // Gold (fades after a day per spec)
    cancelled: 'transparent',     // visual de-emphasis instead of stripe
  },

  // Stripe overlays (override status stripe when applicable)
  overdue: '#C76B3A',             // Ember stripe for past-due commitments
  blocked: '#8A8880',             // Stone stripe for blocked

  // Priority indicators
  priorityHigh: '#C76B3A',        // Ember dot for high priority
  // Medium and low priority have no marker (priorityHigh is the only signal)

  // Shadow source (used by shadows.ts; included here for reference)
  shadowInk: 'rgba(11, 11, 15, 0.06)',
} as const;

export type Colors = typeof colors;
